import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6239859e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "body-box"
};
const _hoisted_2 = {
  class: "moreInfoArea"
};
const _hoisted_3 = {
  id: "contact-box",
  style: {
    "text-align": "center",
    "width": "100%"
  }
};
const _hoisted_4 = {
  class: "contact-box-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_6 = {
  class: "form-box"
};
const _hoisted_7 = {
  class: "form-row"
};
const _hoisted_8 = {
  class: "form-row"
};
const _hoisted_9 = {
  class: "form-row form-rowAPP"
};
import { onMounted, reactive, toRefs, watch, ref, onUnmounted } from "vue";
import request from "../util/request";
import { useRoute, useRouter } from "vue-router";
import "@splidejs/vue-splide/css/skyblue";
import { ElMessage } from "element-plus";
// setup() {

export default {
  __name: 'getQuote',
  setup(__props) {
    const firstScroll = ref(true);
    const scTop = ref(0);
    const isDown = ref();
    const router = useRouter();
    const ispc = ref(true);
    const formData = reactive({
      name: "",
      unitName: "",
      email: "",
      phone: "",
      consultingValue: "",
      area: ""
    });
    const language = ref(sessionStorage.getItem("language"));
    const submit = async () => {
      if (!formData.name) {
        ElMessage.error(getname().name);
        return false;
      }
      if (!formData.email) {
        ElMessage.error(getname().email);
        return false;
      }
      if (!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/.test(formData.email)) {
        ElMessage.error(getname().emailRules);
        return false;
      }
      if (!formData.consultingValue) {
        ElMessage.error(getname().consultingValue);
        return false;
      }
      await request({
        url: "/jodell/consulting/saveConsulting",
        method: "post",
        data: formData
      });
      ElMessage.success(getname().successMessage);
      router.push({
        name: "thanks"
      });
    };
    const getname = () => {
      let list = {
        name: "输入您的姓名",
        email: "输入您的邮箱",
        phone: "输入您的手机号",
        unitName: "输入您的公司全称",
        consultingValue: "输入您的需求",
        area: "输入您的地区",
        submit: "提交信息",
        rules: "请输入正确的手机号",
        titleTop: "欢迎您的咨询",
        titleBottom: "我们会在当日将报价单发给您！",
        successMessage: "提交成功",
        emailRules: "请输入正确的邮箱"
      };
      switch (language.value) {
        case "cn":
          list = {
            name: "输入您的姓名",
            email: "输入您的邮箱",
            phone: "输入您的手机号",
            unitName: "输入您的公司全称",
            consultingValue: "输入您的需求",
            submit: "提交信息",
            area: "输入您的地区",
            rules: "请输入正确的手机号",
            titleTop: "欢迎您的咨询",
            titleBottom: "我们会在当日将报价单发给您！",
            successMessage: "提交成功",
            emailRules: "请输入正确的邮箱"
          };
          break;
        case "en":
          list = {
            name: "Your name",
            email: "Email address",
            phone: "Phone number",
            consultingValue: "Your inquiry",
            submit: "submit",
            area: "Where are you",
            unitName: "Company name",
            titleTop: "We welcome your inquiries and",
            titleBottom: "will send you a quotation on the same day！",
            successMessage: "Submitted successfully",
            emailRules: "Please enter the correct email address"
          };
          break;
        case "jp":
          list = {
            name: "お名前",
            email: "メールアドレス",
            phone: "お電話",
            consultingValue: "お問い合わせ内容",
            submit: "提出",
            area: "エリア",
            rules: "正しい携帯番号を入力してください",
            unitName: "会社名",
            titleTop: "お問い合わせをお待ちしております",
            titleBottom: "当日中に見積もり書をお送りいたします!",
            successMessage: "コミット成功",
            emailRules: "正しいメールアドレスを入力してください"
          };
          break;
        case "kr":
          list = {
            name: "고객님의호칭",
            email: "이메일",
            phone: "전화번호",
            consultingValue: "문의하실 내용과",
            submit: "정보 제출",
            area: "지역",
            rules: "정확한 핸드폰 번호를 입력하세요.",
            unitName: "회사명",
            titleTop: "저희는 문의를 환영합니다",
            titleBottom: "우리는 당일 견적서를 당신에게 보낼 것입니다!",
            successMessage: "커밋 성공",
            emailRules: "올바른 메일박스를 입력하십시오."
          };
          break;
        default:
          break;
      }
      return list;
    };
    // }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(getname().titleTop), 1), _hoisted_5, _createTextVNode(_toDisplayString(getname().titleBottom), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
        model: formData,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form_item, {
          style: {
            "margin-bottom": "15px"
          },
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input inputafter",
            placeholder: getname().name,
            modelValue: formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.name = $event)
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-bottom": "15px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input",
            placeholder: getname().unitName,
            modelValue: formData.unitName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.unitName = $event)
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form_item, {
          style: {
            "margin-bottom": "15px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input inputafter",
            placeholder: getname().email,
            modelValue: formData.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.email = $event)
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-bottom": "15px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input",
            placeholder: getname().phone,
            modelValue: formData.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.phone = $event)
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: getname().area,
            class: "input",
            modelValue: formData.area,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.area = $event),
            style: {
              "width": "100%"
            }
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          style: {
            "margin-bottom": "47.5px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            class: "input-textarea inputafter",
            placeholder: getname().consultingValue,
            modelValue: formData.consultingValue,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.consultingValue = $event),
            rows: 6
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "subButton",
          onClick: _cache[6] || (_cache[6] = $event => submit())
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(getname().submit), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])])]);
    };
  }
};